import { observer } from "mobx-react";
import { NoManagingDirectorForm } from "./noManagingDirectorDomain";
import { Alert } from "@/components-v2/Alert";
import { useState } from "react";
import { LinkButton } from "@/components-v2/Button";
import { Box, VBox } from "@/components-v2/Box";
import { getFullName } from "@/utils/Roles";
import { Markdown } from "@/text/Markdown";

import { useTranslation } from "@/stores/RootStoreContext";

export const NoManagingDirectorFormView = observer(function NoManagingDirectorFormView({
  form,
}: {
  form: NoManagingDirectorForm;
}) {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const missing = form.companiesWithoutManagingDirector;
  const managingDirector = form.managingDirector;
  return form.allCompaniesHaveManagingDirector ? (
    <VBox gap={"md"}>
      {form.context.companies.length === 1 && managingDirector && (
        <div>
          <div>{t("decisions.noManagingDirector.company-managingDirector-now")}</div>
          {getFullName(managingDirector)}
        </div>
      )}
      {showMore ? (
        <div className={"content"}>
          <div>{t("decisionType.noManagingDirector.text")}</div>
          <Box paddingTop={"sm"}>{t("kindly_note")}</Box>
          <Box paddingLeft={"md"} paddingTop={false}>
            <ul>
              <li>{t("decisionType.noManagingDirector.text.li1")}</li>
              <li>{t("decisionType.noManagingDirector.text.li2")}</li>
            </ul>
          </Box>
          <LinkButton label={t("list.showLess")} onClick={() => setShowMore(false)} />
        </div>
      ) : (
        <div>
          {t("decisionType.noManagingDirector.text").slice(0, 40)}
          {"..."}
          <LinkButton label={t("list.showMore")} onClick={() => setShowMore(true)} />
        </div>
      )}
      {form.isManagingDirectorAttendingBoardMeeting && (
        <Alert
          type={"info"}
          message={
            <Markdown
              value={t("decisions.noManagingDirector.managingDirector-attending")}
              enableLinks
              inheritLinkColor
              disableLastMargin
              onActionClick={form.openBoardMeetingParticipants}
            />
          }
        />
      )}
    </VBox>
  ) : (
    <div>
      <Alert
        message={t({
          key: "decisionType.noManagingDirector.companyHasNoManagingDirector",
          params: {
            count: missing.length,
            companies: { type: "list", value: missing.map((c) => c.name) },
          },
        })}
        type={"error"}
      />
    </div>
  );
});
